import { jsx, jsxs } from "react/jsx-runtime";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider as ThemeProvider$1 } from "@mui/material/styles";
import { useState, useMemo, useCallback } from "react";
import defaultTheme from "../default/index.js";
import ThemeContext from "./Context.js";
const defaultMode = "light";
const ThemeProvider = ({
  children
}) => {
  const [themeMode, setThemeMode] = useState(defaultTheme.palette?.mode || defaultMode);
  const theme = useMemo(() => createTheme(defaultTheme),
  // `themeMode` is unused here only because `createTheme` ignores it — dark mode is wired up in the
  // context but never connected. Kept as the sole evidence of that intent; fix the body, not this.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [themeMode]);
  const toggleTheme = useCallback(mode => {
    setThemeMode(prev => prev !== mode ? mode : prev);
  }, []);
  const providerValue = useMemo(() => ({
    theme,
    mode: themeMode,
    toggleTheme
  }), [theme, themeMode, toggleTheme]);
  return /* @__PURE__ */jsx(ThemeContext.Provider, {
    value: providerValue,
    children: /* @__PURE__ */jsxs(ThemeProvider$1, {
      theme,
      children: [/* @__PURE__ */jsx(CssBaseline, {}), children]
    })
  });
};
export { ThemeProvider as default };